import { Link } from "react-router-dom";
import { hotTopics } from "@/mocks/hotList";

interface HotRankListProps {
  limit?: number;
  compact?: boolean;
}

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line text-primary-600",
  down: "ri-arrow-down-line text-secondary-600",
  flat: "ri-subtract-line text-foreground-400",
};

export default function HotRankList({ limit, compact = false }: HotRankListProps) {
  const list = limit ? hotTopics.slice(0, limit) : hotTopics;

  return (
    <ol className={compact ? "flex flex-col" : "flex flex-col gap-1"}>
      {list.map((topic) => (
        <li key={topic.rank}>
          <Link
            to={`/article/${topic.articleId}`}
            className="group flex items-center gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-100"
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-xs font-label font-bold ${
                topic.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600"
              }`}
            >
              {topic.rank}
            </span>
            <span className="min-w-0 flex-1">
              <span className="line-clamp-1 block text-sm font-label text-foreground-800 transition-colors group-hover:text-primary-700">
                {topic.title}
              </span>
              <span className="mt-0.5 flex items-center gap-2 text-xs font-label text-foreground-400">
                <span>{topic.heat}万热度</span>
                <i className={`${trendIcon[topic.trend]} text-xs`}></i>
              </span>
            </span>
            <span className="hidden shrink-0 rounded-full bg-secondary-50 px-2 py-0.5 text-xs font-label text-secondary-700 sm:block">
              {topic.tag}
            </span>
          </Link>
        </li>
      ))}
    </ol>
  );
}